<template>
  <div @click="handleCTAClick()">
    <div
      v-if="dataBannerImg"
      :class="dataBannerImgStyle"
      :style="getBannerStyle"
    >
      <img :src="dataBannerImg" :style="getImageStyle" />
    </div>
    <div class="card-content">
      <div
        class="pr flex-column hero-banner-content"
        :style="{ textAlign: dataTextAlign }"
      >
        <p class="hero-title" :style="getTitleStyle">{{ dataTitle }}</p>
        <p class="hero-description" :style="getSubtitleStyle">
          {{ dataSubTitle }}
        </p>
        <button
          class="hero-action"
          :style="getDataActionStyle"
          @click="handleCTAClick()"
        >
          {{ dataCtaText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  EVENT_IMPRESSION_PROMOTION,
  EVENT_CLICK_PROMOTION,
} from "../helpers/analyticsEvents";

import {
  keyMapsAction,
  keyMapsGetter,
  keyMapsMutation,
} from "../helpers/storeKeys";

import Utility from "../helpers/utility";
export default {
  name: "HeroBanners",
  props: [
    "dataTitle",
    "dataSubTitle",
    "dataCtaText",
    "dataBannerImg",
    "dataJustifyImgContent",
    "dataTitleColor",
    "dataSubTitleColor",
    "dataActionButtonColor",
    "dataActionButtonBackground",
    "dataTextAlign",
    "dataImgOpacity",
    "dataBannerImgStyle",
    "dataAction",
    "dataCoupon",
    "dataImgLeft",
    "dataImgWidth",
    "dataImgHeight",
  ],
  mounted() {
    EVENT_IMPRESSION_PROMOTION({
      ecommerce: {
        promotions: [
          {
            promotion_id: "",
            promotion_name: this.dataSubTitle,
            creative_name: "",
            creative_slot: "top",
          },
        ],
      },
    });
  },
  computed: {
    getBannerStyle() {
      return {
        justifyContent: this.dataJustifyImgContent,
        left: this.dataImgLeft,
      };
    },
    getImageStyle() {
      return {
        opacity: this.dataImgOpacity,
        width: this.dataImgWidth,
        height: this.dataImgHeight,
      };
    },
    getTitleStyle() {
      return { color: this.dataTitleColor };
    },
    getSubtitleStyle() {
      return { color: this.dataSubTitleColor };
    },
    getDataActionStyle() {
      return {
        color: this.dataActionButtonColor,
        background: this.dataActionButtonBackground,
      };
    },
  },
  methods: {
    handleCTAClick() {
      if (this.dataAction.includes("/offers")) {
        Utility.sendToOffersScreen();
        // const redirectUrl = this.dataAction + "?offerId=" + this.dataCoupon;
        // Utility.redirectToLinkRewrite(redirectUrl);
      } else if (this.dataAction.includes("catg_id")) {
        Utility.gotoElement({ id: this.dataAction.replace("catg_id=", "") });
      } else if (this.dataAction.includes("prod_id")) {
        Utility.gotoElement({
          type: "PRODUCT",
          id: this.dataAction.replace("prod_id=", ""),
        });
      } else if (this.dataAction.includes("/menu")) {
        Utility.sendToMenuScreen();
      }
      EVENT_CLICK_PROMOTION({
        ecommerce: {
          promotions: [
            {
              promotion_id: "",
              promotion_name: this.dataSubTitle,
              creative_name: "",
              creative_slot: "top",
            },
          ],
        },
      });
    },
  },
};
</script>

<style></style>
